import NotificationBellIcon from './component.jsx'
export default NotificationBellIcon
